<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Amnon Levy is a PhD holder from the University of California at Berkeley and a University of Wollongong Professor of Economics. In addition to efficiency and sustainability, he has focused on fairness in the allocations of opportunities and on investments in human capital, health, and communication as instruments for social mobility, integration, wellbeing and peace. He spent the first forty years of his life in the disputed, violently contested, ethnically fragmented and environmentally degraded “Holy Land” and served as a tenured Senior Lecturer in Economics at Ben-Gurion University of the Negev. In 1990, he moved to live in “The Dreamland” of the Aboriginal peoples, “The Lucky Country Down Under” of the white convicts and fresh-start seekers and “The Hard Yakka Land” of the yellow, brown and black refugees and skilled-labour immigrants.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7e077962